import { z } from 'zod'

export default z.object({
  __typename: z.literal('ContractRenovation').default('ContractRenovation'),
  id: z.number(),
})
